const map = {
	"./activity-details.svg": "./src/assets/icons/activity-details.svg",
	"./activity-flag.svg": "./src/assets/icons/activity-flag.svg",
	"./add-patient-success.svg": "./src/assets/icons/add-patient-success.svg",
	"./add-patient.svg": "./src/assets/icons/add-patient.svg",
	"./admin.svg": "./src/assets/icons/admin.svg",
	"./administration.svg": "./src/assets/icons/administration.svg",
	"./archived-users-directory.svg": "./src/assets/icons/archived-users-directory.svg",
	"./arrow-simple-left.svg": "./src/assets/icons/arrow-simple-left.svg",
	"./arrow-simple-right.svg": "./src/assets/icons/arrow-simple-right.svg",
	"./assets.svg": "./src/assets/icons/assets.svg",
	"./att-current.svg": "./src/assets/icons/att-current.svg",
	"./att-history.svg": "./src/assets/icons/att-history.svg",
	"./audit-trail-logs.svg": "./src/assets/icons/audit-trail-logs.svg",
	"./body.svg": "./src/assets/icons/body.svg",
	"./button-icon-save.svg": "./src/assets/icons/button-icon-save.svg",
	"./calendar.svg": "./src/assets/icons/calendar.svg",
	"./calibration-off.svg": "./src/assets/icons/calibration-off.svg",
	"./calibration-on.svg": "./src/assets/icons/calibration-on.svg",
	"./callout-down.svg": "./src/assets/icons/callout-down.svg",
	"./callout.svg": "./src/assets/icons/callout.svg",
	"./ce.svg": "./src/assets/icons/ce.svg",
	"./chevron-carousel-left.svg": "./src/assets/icons/chevron-carousel-left.svg",
	"./chevron-carousel-right.svg": "./src/assets/icons/chevron-carousel-right.svg",
	"./chevron-down.svg": "./src/assets/icons/chevron-down.svg",
	"./chevron-left.svg": "./src/assets/icons/chevron-left.svg",
	"./chevron-right.svg": "./src/assets/icons/chevron-right.svg",
	"./chevron-up.svg": "./src/assets/icons/chevron-up.svg",
	"./circle-warning.svg": "./src/assets/icons/circle-warning.svg",
	"./close.svg": "./src/assets/icons/close.svg",
	"./cog-hollow.svg": "./src/assets/icons/cog-hollow.svg",
	"./companion-logo.svg": "./src/assets/icons/companion-logo.svg",
	"./compensation/bodyweighttransfer-left.svg": "./src/assets/icons/compensation/bodyweighttransfer-left.svg",
	"./compensation/bodyweighttransfer-right.svg": "./src/assets/icons/compensation/bodyweighttransfer-right.svg",
	"./compensation/leftkneeextension-up.svg": "./src/assets/icons/compensation/leftkneeextension-up.svg",
	"./compensation/leftshoulderabductionadduction-left.svg": "./src/assets/icons/compensation/leftshoulderabductionadduction-left.svg",
	"./compensation/leftshoulderabductionadduction-right.svg": "./src/assets/icons/compensation/leftshoulderabductionadduction-right.svg",
	"./compensation/leftshoulderflexionextension-backward.svg": "./src/assets/icons/compensation/leftshoulderflexionextension-backward.svg",
	"./compensation/leftshoulderflexionextension-forward.svg": "./src/assets/icons/compensation/leftshoulderflexionextension-forward.svg",
	"./compensation/rightkneeextension-up.svg": "./src/assets/icons/compensation/rightkneeextension-up.svg",
	"./compensation/rightshoulderabductionadduction-left.svg": "./src/assets/icons/compensation/rightshoulderabductionadduction-left.svg",
	"./compensation/rightshoulderabductionadduction-right.svg": "./src/assets/icons/compensation/rightshoulderabductionadduction-right.svg",
	"./compensation/rightshoulderflexionextension-backward.svg": "./src/assets/icons/compensation/rightshoulderflexionextension-backward.svg",
	"./compensation/rightshoulderflexionextension-forward.svg": "./src/assets/icons/compensation/rightshoulderflexionextension-forward.svg",
	"./compensation/trunkflexion-backward.svg": "./src/assets/icons/compensation/trunkflexion-backward.svg",
	"./compensation/trunkflexion-forward.svg": "./src/assets/icons/compensation/trunkflexion-forward.svg",
	"./compensation/trunkflexion-left.svg": "./src/assets/icons/compensation/trunkflexion-left.svg",
	"./compensation/trunkflexion-right.svg": "./src/assets/icons/compensation/trunkflexion-right.svg",
	"./compensation_flag_icons/elbow-left.svg": "./src/assets/icons/compensation_flag_icons/elbow-left.svg",
	"./compensation_flag_icons/elbow-right.svg": "./src/assets/icons/compensation_flag_icons/elbow-right.svg",
	"./compensation_flag_icons/head-center.svg": "./src/assets/icons/compensation_flag_icons/head-center.svg",
	"./compensation_flag_icons/head-left.svg": "./src/assets/icons/compensation_flag_icons/head-left.svg",
	"./compensation_flag_icons/head-right.svg": "./src/assets/icons/compensation_flag_icons/head-right.svg",
	"./compensation_flag_icons/leg-left.svg": "./src/assets/icons/compensation_flag_icons/leg-left.svg",
	"./compensation_flag_icons/leg-right.svg": "./src/assets/icons/compensation_flag_icons/leg-right.svg",
	"./compensation_flag_icons/shoulder-left.svg": "./src/assets/icons/compensation_flag_icons/shoulder-left.svg",
	"./compensation_flag_icons/shoulder-right.svg": "./src/assets/icons/compensation_flag_icons/shoulder-right.svg",
	"./compensation_flag_icons/torso.svg": "./src/assets/icons/compensation_flag_icons/torso.svg",
	"./compensation_flag_icons/wrist-left.svg": "./src/assets/icons/compensation_flag_icons/wrist-left.svg",
	"./compensation_flag_icons/wrist-right.svg": "./src/assets/icons/compensation_flag_icons/wrist-right.svg",
	"./compensation_groups/bodyweighttransfer.svg": "./src/assets/icons/compensation_groups/bodyweighttransfer.svg",
	"./compensation_groups/leftkneeextension.svg": "./src/assets/icons/compensation_groups/leftkneeextension.svg",
	"./compensation_groups/leftshoulder.svg": "./src/assets/icons/compensation_groups/leftshoulder.svg",
	"./compensation_groups/rightkneeextension.svg": "./src/assets/icons/compensation_groups/rightkneeextension.svg",
	"./compensation_groups/rightshoulder.svg": "./src/assets/icons/compensation_groups/rightshoulder.svg",
	"./compensation_groups/trunkflexion.svg": "./src/assets/icons/compensation_groups/trunkflexion.svg",
	"./consent.svg": "./src/assets/icons/consent.svg",
	"./contact-us.svg": "./src/assets/icons/contact-us.svg",
	"./copy.svg": "./src/assets/icons/copy.svg",
	"./create_program.svg": "./src/assets/icons/create_program.svg",
	"./create_template.svg": "./src/assets/icons/create_template.svg",
	"./credentials.svg": "./src/assets/icons/credentials.svg",
	"./data-export.svg": "./src/assets/icons/data-export.svg",
	"./day-period-afternoon.svg": "./src/assets/icons/day-period-afternoon.svg",
	"./day-period-morning.svg": "./src/assets/icons/day-period-morning.svg",
	"./demo-patient.svg": "./src/assets/icons/demo-patient.svg",
	"./done-half.svg": "./src/assets/icons/done-half.svg",
	"./done-invert-colors.svg": "./src/assets/icons/done-invert-colors.svg",
	"./done-not-training.svg": "./src/assets/icons/done-not-training.svg",
	"./done-not.svg": "./src/assets/icons/done-not.svg",
	"./done-notassigned.svg": "./src/assets/icons/done-notassigned.svg",
	"./done-partially.svg": "./src/assets/icons/done-partially.svg",
	"./done-password-criteria.svg": "./src/assets/icons/done-password-criteria.svg",
	"./done-rounded-circle-fill.svg": "./src/assets/icons/done-rounded-circle-fill.svg",
	"./done-rounded-circle.svg": "./src/assets/icons/done-rounded-circle.svg",
	"./done.svg": "./src/assets/icons/done.svg",
	"./dpo-admin.svg": "./src/assets/icons/dpo-admin.svg",
	"./drag-handle.svg": "./src/assets/icons/drag-handle.svg",
	"./duplicate.svg": "./src/assets/icons/duplicate.svg",
	"./e-ifu.svg": "./src/assets/icons/e-ifu.svg",
	"./edit.svg": "./src/assets/icons/edit.svg",
	"./email.svg": "./src/assets/icons/email.svg",
	"./epro-add.svg": "./src/assets/icons/epro-add.svg",
	"./epro-bar.svg": "./src/assets/icons/epro-bar.svg",
	"./epro-calendar-outline.svg": "./src/assets/icons/epro-calendar-outline.svg",
	"./epro-calendar.svg": "./src/assets/icons/epro-calendar.svg",
	"./epro-checkmark-circle.svg": "./src/assets/icons/epro-checkmark-circle.svg",
	"./epro-chevron-down.svg": "./src/assets/icons/epro-chevron-down.svg",
	"./epro-chevron-left.svg": "./src/assets/icons/epro-chevron-left.svg",
	"./epro-chevron-right.svg": "./src/assets/icons/epro-chevron-right.svg",
	"./epro-clock.svg": "./src/assets/icons/epro-clock.svg",
	"./epro-close.svg": "./src/assets/icons/epro-close.svg",
	"./epro-download.svg": "./src/assets/icons/epro-download.svg",
	"./epro-eye.svg": "./src/assets/icons/epro-eye.svg",
	"./epro-info.svg": "./src/assets/icons/epro-info.svg",
	"./epro-list.svg": "./src/assets/icons/epro-list.svg",
	"./epro-loader.svg": "./src/assets/icons/epro-loader.svg",
	"./epro-message-circle.svg": "./src/assets/icons/epro-message-circle.svg",
	"./epro-minus.svg": "./src/assets/icons/epro-minus.svg",
	"./epro-more-vertical.svg": "./src/assets/icons/epro-more-vertical.svg",
	"./epro-password.svg": "./src/assets/icons/epro-password.svg",
	"./epro-patients.svg": "./src/assets/icons/epro-patients.svg",
	"./epro-refresh.svg": "./src/assets/icons/epro-refresh.svg",
	"./epro-search.svg": "./src/assets/icons/epro-search.svg",
	"./epro-sync.svg": "./src/assets/icons/epro-sync.svg",
	"./epro-timer.svg": "./src/assets/icons/epro-timer.svg",
	"./european-representative.svg": "./src/assets/icons/european-representative.svg",
	"./export.svg": "./src/assets/icons/export.svg",
	"./external.svg": "./src/assets/icons/external.svg",
	"./faq.svg": "./src/assets/icons/faq.svg",
	"./feedback.svg": "./src/assets/icons/feedback.svg",
	"./filter.svg": "./src/assets/icons/filter.svg",
	"./flags/ar-SA.svg": "./src/assets/icons/flags/ar-SA.svg",
	"./flags/de.svg": "./src/assets/icons/flags/de.svg",
	"./flags/es.svg": "./src/assets/icons/flags/es.svg",
	"./flags/fr.svg": "./src/assets/icons/flags/fr.svg",
	"./flags/gb.svg": "./src/assets/icons/flags/gb.svg",
	"./flags/it.svg": "./src/assets/icons/flags/it.svg",
	"./flags/jp.svg": "./src/assets/icons/flags/jp.svg",
	"./flags/ro.svg": "./src/assets/icons/flags/ro.svg",
	"./flags/us.svg": "./src/assets/icons/flags/us.svg",
	"./general-details.svg": "./src/assets/icons/general-details.svg",
	"./geolocalization.svg": "./src/assets/icons/geolocalization.svg",
	"./globe.svg": "./src/assets/icons/globe.svg",
	"./hamburger.svg": "./src/assets/icons/hamburger.svg",
	"./hand.svg": "./src/assets/icons/hand.svg",
	"./help.svg": "./src/assets/icons/help.svg",
	"./ifu.svg": "./src/assets/icons/ifu.svg",
	"./import.svg": "./src/assets/icons/import.svg",
	"./import_mm_template.svg": "./src/assets/icons/import_mm_template.svg",
	"./import_my_template.svg": "./src/assets/icons/import_my_template.svg",
	"./info-circle.svg": "./src/assets/icons/info-circle.svg",
	"./level.svg": "./src/assets/icons/level.svg",
	"./levels.svg": "./src/assets/icons/levels.svg",
	"./license.svg": "./src/assets/icons/license.svg",
	"./loading.svg": "./src/assets/icons/loading.svg",
	"./logout.svg": "./src/assets/icons/logout.svg",
	"./manufacture-date.svg": "./src/assets/icons/manufacture-date.svg",
	"./manufacturer.svg": "./src/assets/icons/manufacturer.svg",
	"./md.svg": "./src/assets/icons/md.svg",
	"./medical-details.svg": "./src/assets/icons/medical-details.svg",
	"./menu.svg": "./src/assets/icons/menu.svg",
	"./mindmotion-logo.svg": "./src/assets/icons/mindmotion-logo.svg",
	"./mini-cam.svg": "./src/assets/icons/mini-cam.svg",
	"./mini-mic.svg": "./src/assets/icons/mini-mic.svg",
	"./mini-sound.svg": "./src/assets/icons/mini-sound.svg",
	"./more-menu.svg": "./src/assets/icons/more-menu.svg",
	"./movement/ArmReaching.svg": "./src/assets/icons/movement/ArmReaching.svg",
	"./movement/ArmReachingAndPalmarGrasping.svg": "./src/assets/icons/movement/ArmReachingAndPalmarGrasping.svg",
	"./movement/ArmsPumping.svg": "./src/assets/icons/movement/ArmsPumping.svg",
	"./movement/BilateralStep.svg": "./src/assets/icons/movement/BilateralStep.svg",
	"./movement/FingersPinch.svg": "./src/assets/icons/movement/FingersPinch.svg",
	"./movement/ForearmPronationSupination.svg": "./src/assets/icons/movement/ForearmPronationSupination.svg",
	"./movement/ForwardBackwardSteps.svg": "./src/assets/icons/movement/ForwardBackwardSteps.svg",
	"./movement/FreeSqueeze.svg": "./src/assets/icons/movement/FreeSqueeze.svg",
	"./movement/FreeSqueezeAndFreeWristMovement.svg": "./src/assets/icons/movement/FreeSqueezeAndFreeWristMovement.svg",
	"./movement/FreeSteps.svg": "./src/assets/icons/movement/FreeSteps.svg",
	"./movement/FreeWristMovement.svg": "./src/assets/icons/movement/FreeWristMovement.svg",
	"./movement/GripFlexionExtension.svg": "./src/assets/icons/movement/GripFlexionExtension.svg",
	"./movement/GripPronationSupination.svg": "./src/assets/icons/movement/GripPronationSupination.svg",
	"./movement/GripRadialUlnarDeviation.svg": "./src/assets/icons/movement/GripRadialUlnarDeviation.svg",
	"./movement/HandGraspRelease.svg": "./src/assets/icons/movement/HandGraspRelease.svg",
	"./movement/HorizontalArmReaching.svg": "./src/assets/icons/movement/HorizontalArmReaching.svg",
	"./movement/HorizontalShoulderAbductionAdduction.svg": "./src/assets/icons/movement/HorizontalShoulderAbductionAdduction.svg",
	"./movement/LateralBodyWeightTransfer.svg": "./src/assets/icons/movement/LateralBodyWeightTransfer.svg",
	"./movement/LateralStep.svg": "./src/assets/icons/movement/LateralStep.svg",
	"./movement/PalmarGrasp.svg": "./src/assets/icons/movement/PalmarGrasp.svg",
	"./movement/PincerGrasp.svg": "./src/assets/icons/movement/PincerGrasp.svg",
	"./movement/ShoulderAbduction.svg": "./src/assets/icons/movement/ShoulderAbduction.svg",
	"./movement/ShoulderAbductionAdduction.svg": "./src/assets/icons/movement/ShoulderAbductionAdduction.svg",
	"./movement/ShoulderFlexion.svg": "./src/assets/icons/movement/ShoulderFlexion.svg",
	"./movement/ShoulderFlexionExtension.svg": "./src/assets/icons/movement/ShoulderFlexionExtension.svg",
	"./movement/Squat.svg": "./src/assets/icons/movement/Squat.svg",
	"./movement/SteeringWheel.svg": "./src/assets/icons/movement/SteeringWheel.svg",
	"./movement/SteeringWheelAndArmsPumping.svg": "./src/assets/icons/movement/SteeringWheelAndArmsPumping.svg",
	"./movement/TrunkAxialRotation.svg": "./src/assets/icons/movement/TrunkAxialRotation.svg",
	"./movement/TrunkForwardBackwardFlexion.svg": "./src/assets/icons/movement/TrunkForwardBackwardFlexion.svg",
	"./movement/TrunkForwardBackwardLateralFlexion.svg": "./src/assets/icons/movement/TrunkForwardBackwardLateralFlexion.svg",
	"./movement/TrunkLateralFlexion.svg": "./src/assets/icons/movement/TrunkLateralFlexion.svg",
	"./movement/UnilateralShoulderAbductionAdduction.svg": "./src/assets/icons/movement/UnilateralShoulderAbductionAdduction.svg",
	"./movement/UnilateralStep.svg": "./src/assets/icons/movement/UnilateralStep.svg",
	"./movement/UpperLimbFlexionExtension.svg": "./src/assets/icons/movement/UpperLimbFlexionExtension.svg",
	"./movement/UpperLimbFlexionExtensionAndTrunkLateralFlexion.svg": "./src/assets/icons/movement/UpperLimbFlexionExtensionAndTrunkLateralFlexion.svg",
	"./movement/VerticalHandsReaching.svg": "./src/assets/icons/movement/VerticalHandsReaching.svg",
	"./movement/WorldFootsteps.svg": "./src/assets/icons/movement/WorldFootsteps.svg",
	"./movement/WristFlexionExtension.svg": "./src/assets/icons/movement/WristFlexionExtension.svg",
	"./movement/WristRadialUlnarDeviation.svg": "./src/assets/icons/movement/WristRadialUlnarDeviation.svg",
	"./my-patients.svg": "./src/assets/icons/my-patients.svg",
	"./notifications.svg": "./src/assets/icons/notifications.svg",
	"./optional-features-def.svg": "./src/assets/icons/optional-features-def.svg",
	"./optional-features.svg": "./src/assets/icons/optional-features.svg",
	"./patient-details.svg": "./src/assets/icons/patient-details.svg",
	"./patient-recent.svg": "./src/assets/icons/patient-recent.svg",
	"./patient.svg": "./src/assets/icons/patient.svg",
	"./patient_state/borg/borg-0.svg": "./src/assets/icons/patient_state/borg/borg-0.svg",
	"./patient_state/borg/borg-1.svg": "./src/assets/icons/patient_state/borg/borg-1.svg",
	"./patient_state/borg/borg-10.svg": "./src/assets/icons/patient_state/borg/borg-10.svg",
	"./patient_state/borg/borg-2.svg": "./src/assets/icons/patient_state/borg/borg-2.svg",
	"./patient_state/borg/borg-3.svg": "./src/assets/icons/patient_state/borg/borg-3.svg",
	"./patient_state/borg/borg-4.svg": "./src/assets/icons/patient_state/borg/borg-4.svg",
	"./patient_state/borg/borg-5.svg": "./src/assets/icons/patient_state/borg/borg-5.svg",
	"./patient_state/borg/borg-6.svg": "./src/assets/icons/patient_state/borg/borg-6.svg",
	"./patient_state/borg/borg-7.svg": "./src/assets/icons/patient_state/borg/borg-7.svg",
	"./patient_state/borg/borg-8.svg": "./src/assets/icons/patient_state/borg/borg-8.svg",
	"./patient_state/borg/borg-9.svg": "./src/assets/icons/patient_state/borg/borg-9.svg",
	"./patient_state/mood/bad.svg": "./src/assets/icons/patient_state/mood/bad.svg",
	"./patient_state/mood/good.svg": "./src/assets/icons/patient_state/mood/good.svg",
	"./patient_state/mood/okay.svg": "./src/assets/icons/patient_state/mood/okay.svg",
	"./patient_state/mood/veryBad.svg": "./src/assets/icons/patient_state/mood/veryBad.svg",
	"./patient_state/mood/veryGood.svg": "./src/assets/icons/patient_state/mood/veryGood.svg",
	"./patient_state/skipped.svg": "./src/assets/icons/patient_state/skipped.svg",
	"./patients.svg": "./src/assets/icons/patients.svg",
	"./peripherals/Kinect.svg": "./src/assets/icons/peripherals/Kinect.svg",
	"./peripherals/LeapMotion.svg": "./src/assets/icons/peripherals/LeapMotion.svg",
	"./peripherals/MMB_1x.svg": "./src/assets/icons/peripherals/MMB_1x.svg",
	"./peripherals/MMB_2x.svg": "./src/assets/icons/peripherals/MMB_2x.svg",
	"./planner-calendar.svg": "./src/assets/icons/planner-calendar.svg",
	"./planner-calibrate.svg": "./src/assets/icons/planner-calibrate.svg",
	"./planner-download.svg": "./src/assets/icons/planner-download.svg",
	"./planner-dropper.svg": "./src/assets/icons/planner-dropper.svg",
	"./planner-file.svg": "./src/assets/icons/planner-file.svg",
	"./planner-log.svg": "./src/assets/icons/planner-log.svg",
	"./planner-minus.svg": "./src/assets/icons/planner-minus.svg",
	"./planner-options.svg": "./src/assets/icons/planner-options.svg",
	"./planner-plus.svg": "./src/assets/icons/planner-plus.svg",
	"./planner-results.svg": "./src/assets/icons/planner-results.svg",
	"./planner-settings.svg": "./src/assets/icons/planner-settings.svg",
	"./planner-trash.svg": "./src/assets/icons/planner-trash.svg",
	"./play.svg": "./src/assets/icons/play.svg",
	"./posture-seat.svg": "./src/assets/icons/posture-seat.svg",
	"./posture-stand.svg": "./src/assets/icons/posture-stand.svg",
	"./profile-admin.svg": "./src/assets/icons/profile-admin.svg",
	"./profile-patient.svg": "./src/assets/icons/profile-patient.svg",
	"./profile-patient_full.svg": "./src/assets/icons/profile-patient_full.svg",
	"./profile-physician.svg": "./src/assets/icons/profile-physician.svg",
	"./profile-sitemanager.svg": "./src/assets/icons/profile-sitemanager.svg",
	"./profile-sitemanager_full.svg": "./src/assets/icons/profile-sitemanager_full.svg",
	"./profile-support.svg": "./src/assets/icons/profile-support.svg",
	"./profile-therapist.svg": "./src/assets/icons/profile-therapist.svg",
	"./profile-therapist_full.svg": "./src/assets/icons/profile-therapist_full.svg",
	"./random.svg": "./src/assets/icons/random.svg",
	"./ref.svg": "./src/assets/icons/ref.svg",
	"./reload.svg": "./src/assets/icons/reload.svg",
	"./rx.svg": "./src/assets/icons/rx.svg",
	"./save_as_template.svg": "./src/assets/icons/save_as_template.svg",
	"./search.svg": "./src/assets/icons/search.svg",
	"./session-scheduled.svg": "./src/assets/icons/session-scheduled.svg",
	"./settings-light.svg": "./src/assets/icons/settings-light.svg",
	"./settings.svg": "./src/assets/icons/settings.svg",
	"./sidebar-close.svg": "./src/assets/icons/sidebar-close.svg",
	"./sidebar-open.svg": "./src/assets/icons/sidebar-open.svg",
	"./site-management.svg": "./src/assets/icons/site-management.svg",
	"./site-managers.svg": "./src/assets/icons/site-managers.svg",
	"./sort.svg": "./src/assets/icons/sort.svg",
	"./sort_asc.svg": "./src/assets/icons/sort_asc.svg",
	"./sort_desc.svg": "./src/assets/icons/sort_desc.svg",
	"./star.svg": "./src/assets/icons/star.svg",
	"./stop.svg": "./src/assets/icons/stop.svg",
	"./swissMadeSoftware.svg": "./src/assets/icons/swissMadeSoftware.svg",
	"./teleconsultation.svg": "./src/assets/icons/teleconsultation.svg",
	"./templates-directory.svg": "./src/assets/icons/templates-directory.svg",
	"./templates-editor.svg": "./src/assets/icons/templates-editor.svg",
	"./therapeutic-goal.svg": "./src/assets/icons/therapeutic-goal.svg",
	"./therapist-details.svg": "./src/assets/icons/therapist-details.svg",
	"./therapists.svg": "./src/assets/icons/therapists.svg",
	"./tick.svg": "./src/assets/icons/tick.svg",
	"./time-zone.svg": "./src/assets/icons/time-zone.svg",
	"./timeline-session-extra-training.svg": "./src/assets/icons/timeline-session-extra-training.svg",
	"./timeline-session-missed.svg": "./src/assets/icons/timeline-session-missed.svg",
	"./timeline-session-supervised.svg": "./src/assets/icons/timeline-session-supervised.svg",
	"./timeline-session-unsupervised.svg": "./src/assets/icons/timeline-session-unsupervised.svg",
	"./top-menu-live-meeting-down.svg": "./src/assets/icons/top-menu-live-meeting-down.svg",
	"./top-menu-live-meeting-up.svg": "./src/assets/icons/top-menu-live-meeting-up.svg",
	"./top-menu-patients-directory-down.svg": "./src/assets/icons/top-menu-patients-directory-down.svg",
	"./top-menu-patients-directory-up.svg": "./src/assets/icons/top-menu-patients-directory-up.svg",
	"./top-menu-telerehab-down.svg": "./src/assets/icons/top-menu-telerehab-down.svg",
	"./top-menu-telerehab-up.svg": "./src/assets/icons/top-menu-telerehab-up.svg",
	"./trained_functions/FunctionAll.svg": "./src/assets/icons/trained_functions/FunctionAll.svg",
	"./trained_functions/FunctionHandBilateral.svg": "./src/assets/icons/trained_functions/FunctionHandBilateral.svg",
	"./trained_functions/FunctionHandLeft.svg": "./src/assets/icons/trained_functions/FunctionHandLeft.svg",
	"./trained_functions/FunctionHandRight.svg": "./src/assets/icons/trained_functions/FunctionHandRight.svg",
	"./trained_functions/FunctionLowerLimbBilateral.svg": "./src/assets/icons/trained_functions/FunctionLowerLimbBilateral.svg",
	"./trained_functions/FunctionLowerLimbLeft.svg": "./src/assets/icons/trained_functions/FunctionLowerLimbLeft.svg",
	"./trained_functions/FunctionLowerLimbRight.svg": "./src/assets/icons/trained_functions/FunctionLowerLimbRight.svg",
	"./trained_functions/FunctionNone.svg": "./src/assets/icons/trained_functions/FunctionNone.svg",
	"./trained_functions/FunctionTrunkBilateral.svg": "./src/assets/icons/trained_functions/FunctionTrunkBilateral.svg",
	"./trained_functions/FunctionTrunkLeft.svg": "./src/assets/icons/trained_functions/FunctionTrunkLeft.svg",
	"./trained_functions/FunctionTrunkRight.svg": "./src/assets/icons/trained_functions/FunctionTrunkRight.svg",
	"./trained_functions/FunctionUpperLimbBilateral.svg": "./src/assets/icons/trained_functions/FunctionUpperLimbBilateral.svg",
	"./trained_functions/FunctionUpperLimbLeft.svg": "./src/assets/icons/trained_functions/FunctionUpperLimbLeft.svg",
	"./trained_functions/FunctionUpperLimbRight.svg": "./src/assets/icons/trained_functions/FunctionUpperLimbRight.svg",
	"./training-plan.svg": "./src/assets/icons/training-plan.svg",
	"./training_materials/next.svg": "./src/assets/icons/training_materials/next.svg",
	"./training_materials/previous.svg": "./src/assets/icons/training_materials/previous.svg",
	"./training_materials/tm-completed-video.svg": "./src/assets/icons/training_materials/tm-completed-video.svg",
	"./training_materials/tm-new-video.svg": "./src/assets/icons/training_materials/tm-new-video.svg",
	"./training_materials/training-material.svg": "./src/assets/icons/training_materials/training-material.svg",
	"./undo.svg": "./src/assets/icons/undo.svg",
	"./unknown.svg": "./src/assets/icons/unknown.svg",
	"./unsupervised-training.svg": "./src/assets/icons/unsupervised-training.svg",
	"./user-sessions.svg": "./src/assets/icons/user-sessions.svg",
	"./videomeeting-mic-off.svg": "./src/assets/icons/videomeeting-mic-off.svg",
	"./videomeeting-mic-on.svg": "./src/assets/icons/videomeeting-mic-on.svg",
	"./videomeeting-sound-off.svg": "./src/assets/icons/videomeeting-sound-off.svg",
	"./videomeeting-sound-on.svg": "./src/assets/icons/videomeeting-sound-on.svg",
	"./videomeeting-video-off.svg": "./src/assets/icons/videomeeting-video-off.svg",
	"./videomeeting-video-on.svg": "./src/assets/icons/videomeeting-video-on.svg",
	"./visibility-hide.svg": "./src/assets/icons/visibility-hide.svg",
	"./visibility-show.svg": "./src/assets/icons/visibility-show.svg",
	"./warning-circle.svg": "./src/assets/icons/warning-circle.svg",
	"./warning.svg": "./src/assets/icons/warning.svg"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*\\.svg$";